import { register } from "async-ops";
import { callMvcApi } from "../../../../../call-web-api";
import { getDefaultOptions } from "../../../../../utils/fetch";

export const DELETE_CURRENT_ROUND = "DELETE_CURRENT_ROUND";

export interface DeleteCurrentRoundParams {
  eaRoundCaseIds: number[];
  previousRoundCaseId?: number;
  newOutcomeId?: number;
}

export const service = async (params: DeleteCurrentRoundParams) => {
  const options: object = {
    url: `/Api/EaCaseApiController/DeleteCurrentRound`,
    method: "POST",
    body: JSON.stringify(params),
    ...getDefaultOptions(),
  };
  return callMvcApi(options);
};

const mock = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ isSaved: true });
    }, 500);
  });
};

register(DELETE_CURRENT_ROUND, service, mock);
